import {
  ButtonNormalSecondaryMedium,
  SectionCenter,
} from '@angeplus/prever-component-lib';

import { SETTINGS } from '../../../config/settings';
import { LinkWrapper } from '@angeplus/prever-component-lib/nextjs';

const urlHubWeb = SETTINGS.public.urlHubWeb;

export const HideAndMeetAngeplus = () => {
  return (
    <SectionCenter>
      <LinkWrapper href={urlHubWeb}>
        <ButtonNormalSecondaryMedium>
          Conhecer o Angeplus
        </ButtonNormalSecondaryMedium>
      </LinkWrapper>
    </SectionCenter>
  );
};
